import { Button } from '@mairistem/composants';

import { ENCAISSEMENT } from '@/constants';

interface ButtonAjoutReglementProps {
  /** Identifiant de test : propre à chaque modale, référencé par ses tests. Pas de défaut. */
  testId: string;
  /**
   * Le bouton reste rendu même masqué (`visibility: hidden`) : sinon la ligne de règlement
   * change de hauteur.
   */
  visible: boolean;
  /** Nombre maximum de règlements atteint : bouton désactivé et libellé explicatif. */
  maximumAtteint: boolean;
  onAdd: () => void;
}

/**
 * Bouton « Ajouter un règlement », passé en `children` à `ModalEncaissementReglements`
 * qui le place sur la première ligne de règlement.
 */
const ButtonAjoutReglement = ({
  testId,
  visible,
  maximumAtteint,
  onAdd,
}: ButtonAjoutReglementProps) => (
  <Button
    data-testid={testId}
    // Pour éviter le submit quand on fait "Entrer"
    // dans les lignes de règlement...
    type="button"
    size="small"
    basic
    primary
    content="Ajouter un règlement"
    icon="copy"
    floated="right"
    onClick={(event) => {
      // nécessaire, sinon la page s'actualise à chaque click
      event.preventDefault();
      onAdd();
    }}
    style={{
      margin: 0,
      width: 205,
      position: 'absolute',
      right: 0,
      // Sinon la ligne bouge en hauteur
      // si on se contente de pas render le Button
      visibility: visible ? 'visible' : 'hidden',
    }}
    {...(maximumAtteint && {
      title: `${ENCAISSEMENT.NOMBRE_REGLEMENTS_MAX} règlements différents maximum`,
      disabled: true,
      primary: false,
      basic: false,
    })}
  />
);

export default ButtonAjoutReglement;
